import styled from '@emotion/styled';
import { Skeleton } from 'antd';
import type { FC } from 'react';
import { staticThemeToken } from '../../../lib/theme';
import { HStack } from '../MetaComponent';
import { type Half, halfColor } from './halfColors';

interface Props {
  currentRange: Half | null;
}

export const ExtraPanelHeader: FC<Props> = ({ currentRange }) => {
  if (currentRange == null) {
    return (
      <Container>
        <Skeleton.Input size="small" style={{ width: 150 }} />
      </Container>
    );
  }

  return (
    <Container style={{ color: halfColor[currentRange] }}>
      {currentRange === 'start' ? 'Start Time' : 'End Time'}
    </Container>
  );
};

const Container = styled(HStack)`
    align-items: center;
    justify-content: flex-start;
    padding: 5px 11px;
    line-height: 24px;
    font-weight: ${staticThemeToken.fontWeightStrong};
    border-bottom: 1px solid ${staticThemeToken.colorBorder};
`;
